import { render, staticRenderFns } from "./EmptyNode.vue?vue&type=template&id=30da60e2&scoped=true&"
import script from "./EmptyNode.vue?vue&type=script&lang=js&"
export * from "./EmptyNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30da60e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30da60e2')) {
      api.createRecord('30da60e2', component.options)
    } else {
      api.reload('30da60e2', component.options)
    }
    module.hot.accept("./EmptyNode.vue?vue&type=template&id=30da60e2&scoped=true&", function () {
      api.rerender('30da60e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/process/comon/process/nodes/EmptyNode.vue"
export default component.exports